// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"94e2a783","319":"253f9eb9","572":"37e2c2cc","823":"d1e0218c"}[chunkId] + ".chunk.js";
};